<template>
<div>
    <div class="header">
        <div class="search">
            <img :src="Images.icon_search" alt="">
            <input type="text" placeholder="输入标题名称搜索" v-model="name">
            <div></div>
            <p @click="refresh">搜索</p>
        </div>
    </div>
    <van-tabs color="#7181EB" title-active-color="#7181EB" v-model="active" @click="onClickTab()">
        <van-tab title="当前沙龙">
            <div class="scrollerView" :style="{ height: (wrapperHeight- 105) + 'px' }">
                <scroller :on-refresh="refresh" :on-infinite="infinite" :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''" ref="infinite" class="scroller">
                    <salonItem v-for="(item, index) in dataSources" :key="index" :item="item" :userType="Constants.USER_STUDENT" />
                    <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
                </scroller>
            </div>
        </van-tab>
        <van-tab title="往期沙龙">
            <div class="scrollerView" :style="{ height: (wrapperHeight- 105) + 'px' }">
                <scroller :on-refresh="refresh" :on-infinite="infinite" :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''" ref="infinite" class="scroller">
                    <salonItem v-for="(item, index) in dataSources" :key="index" :item="item" :userType="Constants.USER_STUDENT" />
                    <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
                </scroller>
            </div>
        </van-tab>
    </van-tabs>
</div>
</template>

<script>
import salonItem from '@/components/item/salonItem'
import {
    setListData
} from '@/utils/tool'
export default {
    /** 组件挂载 */
    components: {
        'salonItem': salonItem,
    },
    setup() {
        const active = 2;
        return {
            active
        };
    },
    /** 数据区 */
    data() {
        return {
            loading: false,
            wrapperHeight: 0, //屏幕高度 - 脚部
            active: 0,
            page: 0,
            limit: 10,
            name: '',
            dataSources: [],
        };
    },
    /** 挂载后 */
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
    },
    /** 方法 */
    methods: {
        // 刷新
        refresh() {
            this.page = 1;
            this.requestData();
            setTimeout(function () {
                this.$refs.infinite.finishPullToRefresh();
            }.bind(this), 1000)
        },
        // 继续请求
        infinite() {
            this.page++
            this.requestData();
        },
        // 请求首页数据
        async requestData() {
            let url = this.API.salon_index;
            let params = {
                page: this.page,
                limit: this.limit,
                tab: this.active, // 0，当前沙龙，1往期沙龙
                name: this.name, // 名词
                token: this.Lockr.get('token')
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                let res = setListData(result.data.list, this.dataSources, this.page, this.limit)
                this.dataSources = res.list
                this.$refs.infinite.finishInfinite(res.finish);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 点击tab
        onClickTab() {
            this.dataSources = []
            this.refresh();
        },
    },
};
</script>

<style lang="less" scoped>
.scrollerView {
    position: relative;
    width: 100%;
}

.scroller {
    background: #F8F8F8;
}

.header {
    position: relative;
    height: 60px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;

    .left-btn {
        width: 36px;
        height: 36px;
        position: absolute;
        top: 50%;
        left: 20px;
        transform: translateY(-50%);
        display: flex;
        justify-content: flex-start;
        align-items: center;

        img {
            display: block;
            height: 20px;
            opacity: .8;
        }
    }

    .search {
        flex: 1;
        padding: 0 10px;
        // margin-left: 30px;
        height: 34px;
        display: flex;
        align-items: center;
        background: #F5F5F5;
        border-radius: 5px;

        img {
            width: 14px;
            height: 14px;
        }

        input {
            flex: 1;
            margin-left: 10px;
            font-size: 14px;
            color: #333;
        }

        div {
            width: 1px;
            height: 15px;
            margin: 0 10px;
            background: #E1D9D9;
        }

        p {
            font-size: 14px;
            color: #666;
        }
    }
}
</style>
